import React from 'react';

export default function AuthView(props) {
  return (
  	<div className="abl-auth-container" id="abl-auth-view"> 
		  <h3>Sign in to Google to access your schedule</h3> 
		  <button id="abl-authorize-button" onClick={props.onClick}> 
		    Sign In 
		  </button> 
		</div>
  );
};



/** WEBPACK FOOTER **
 ** ./src/js/components/auth.js
 **/